<template>
    <div>
        <Alert :alert="subscribeAlert" />
        <form
            class="form-group text-bold"
            :class="{
                busy: busy || (subscribeAlert && subscribeAlert.timeout === 0),
            }"
            style="justify-content: center"
        >
            <text-field
                label="E-mail para cadastro na comunidade"
                autocomplete="email"
                type="email"
                v-model="fields.email"
                input-classes="input-lg"
                :error.sync="errors.email[0]"
            >
            </text-field>
            <text-field
                label="Senha para a comunidade"
                autocomplete="password"
                type="password"
                v-model="fields.password"
                :maxlength="254"
                input-classes="input-lg"
                :error.sync="errors.password[0]"
            ></text-field>
            <text-field
                label="Confirme a senha"
                autocomplete="email"
                type="password"
                v-model="fields.passwordConfirmation"
                :maxlength="254"
                input-classes="input-lg"
                :error.sync="errors.passwordConfirmation[0]"
            ></text-field>
            <loading-button class="btn btn-lg mt-3 btn-wide" @click="subscribe" :loading="busy">
                Cadastrar
            </loading-button>
        </form>
    </div>
</template>

<script>
    import Alert from '../../../../../submodules/src/componentsV2/surface/alert/Alert';
    import TextField from '../../../../../submodules/src/components/input/text-field/TextField.vue';
    import LoadingButton from '../common/LoadingButton';

    export default {
        name: 'Register',

        components: { Alert, TextField, LoadingButton },

        props: {},

        data() {
            return {
                subscribeAlert: null,
                busy: false,
                fields: {
                    email: this.$scope.id ? this.$scope.CUSTOMER.EMAIL : null,
                    password: null,
                },
                errors: {
                    email: [],
                    password: [],
                    passwordConfirmation: [],
                },
            };
        },

        methods: {
            clearErrors() {
                this.errors = Object.assign(
                    {},
                    {
                        email: [],
                        password: [],
                        passwordConfirmation: [],
                    }
                );
            },
            subscribe() {
                if (!this.validate()) {
                    return;
                }
                this.busy = true;

                this.axios.api
                    .post(`prosa_register`, this.fields)
                    .then((response) => {
                        if (response.data.member === true) {
                            this.subscribeAlert = {
                                message:
                                    'Você já está cadastrado! Você será redirecionado para a comunidade em 5 segundos...',
                                timeout: 0,
                            };
                        } else {
                            this.subscribeAlert = {
                                message:
                                    'Seu registro foi realizado com sucesso! Você será redirecionado para a comunidade em 5 segundos...',
                                timeout: 0,
                            };
                        }
                        window.setTimeout(function () {
                            location.href = 'https://prosa.chicorei.com/';
                        }, 5000);
                    })
                    .catch((error) => {
                        this.subscribeAlert = {
                            message:
                                'Para ter acesso a comunidade, você precisa de ao menos um pedido realizado e recebido.',
                            isError: true,
                        };
                    })
                    .then(() => (this.busy = false));
            },

            validate() {
                this.clearErrors();

                if (!this.fields.email) {
                    this.errors.email.push('O email é obrigatório');
                }

                if (!this.fields.password) {
                    this.errors.password.push('Informe uma senha');
                } else if (this.fields.password.length < 6) {
                    this.errors.password.push('A senha deve possuir no mínimo 6 caracteres');
                } else if (
                    !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])/.test(
                        this.fields.password
                    )
                ) {
                    this.errors.password.push(
                        'A senha deve conter ao menos 1 caracter maiúsculo, 1 caracter especial e 1 número'
                    );
                }

                if (!this.fields.passwordConfirmation) {
                    this.errors.passwordConfirmation.push('Digite sua senha novamente');
                } else if (this.fields.passwordConfirmation !== this.fields.password) {
                    this.errors.passwordConfirmation.push(
                        'A confirmação não coincide com a senha informada'
                    );
                }

                return (
                    this.errors.email.length === 0 &&
                    this.errors.password.length === 0 &&
                    this.errors.passwordConfirmation.length === 0
                );
            },
        },
    };
</script>
